import { NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/image/rccglogo.webp";
import CustomModal from "../components/CustomModal";
import { useState } from "react";

export default function SideBar({ isOpen }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogout = () => setShowModal(true);

  const handleDoThisLater = () => {
    setShowModal(false);
  };

  const handleLetsDoThis = async () => {
    setLoading(true);

    try {
      const token = localStorage.getItem("authToken");

      const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;
        const response = await fetch(
        `${TEST_BASE_URL}/logout`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let data;

      if (!response.ok) {
        throw new Error(data.message || "Logout failed");
      }

      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      setShowModal(false);
      navigate("/login");
    } catch (error) {
      console.error("Error during logout:", error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const personIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 84 84"
      fill="none"
    >
      <path
        d="M54.75 65.9062C54.4372 73.7769 47.8782 80.4599 39.0915 80.245C37.0472 80.1949 34.5205 79.4823 29.4673 78.0569C17.3059 74.6266 6.74859 68.8615 4.21561 55.9466C3.75 53.5726 3.75 50.9011 3.75 45.5583L3.75 38.4417C3.75 33.0989 3.75 30.4274 4.21561 28.0534C6.74859 15.1385 17.3059 9.37343 29.4673 5.94311C34.5206 4.51774 37.0472 3.80506 39.0915 3.75505C47.8781 3.54009 54.4372 10.223 54.75 18.0938"
        stroke="white"
        strokeWidth="6.375"
        strokeLinecap="round"
      />
      <path
        d="M80.25 42H33.5M80.25 42C80.25 39.024 71.7742 33.464 69.625 31.375M80.25 42C80.25 44.976 71.7742 50.536 69.625 52.625"
        stroke="white"
        strokeWidth="6.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

    return (
    <div className={`side-bar ${isOpen ? "open" : "closed"}`}>
      <div className="topside-bar">
        <div className="logowrapper">
          <img src={logo} alt="RCCG New Beginning Chapel Logo" />
          <span>
            The Redeemed Christian Church of God, New Beginning Chapel.
          </span>
        </div>
        <p className="text-center pt-2">
          <small>MEMBERSHIP PORTAL</small>
        </p>
      </div>

      <div className="bottomside-bar">
        <NavLink
          to="/"
          end
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M7.99948 21.0239L7.74884 17.515C7.61409 15.6285 9.10819 14.0239 10.9995 14.0239C12.8908 14.0239 14.3849 15.6285 14.2501 17.515L13.9995 21.0239"
              stroke="black"
              strokeWidth="1.5"
            />
            <path
              d="M1.35155 12.2374C0.998528 9.94017 0.822018 8.79156 1.25632 7.7733C1.69063 6.75504 2.65418 6.05836 4.58129 4.66499L6.02114 3.62393C8.41845 1.89059 9.6171 1.02393 11.0002 1.02393C12.3832 1.02393 13.5819 1.89059 15.9792 3.62393L17.419 4.66499C19.3461 6.05836 20.3097 6.75504 20.744 7.7733C21.1783 8.79156 21.0018 9.94017 20.6488 12.2374L20.3477 14.1963C19.8473 17.4528 19.5971 19.0811 18.4292 20.0525C17.2612 21.0239 15.5538 21.0239 12.139 21.0239H9.86134C6.44649 21.0239 4.73906 21.0239 3.57116 20.0525C2.40325 19.0811 2.15303 17.4528 1.65258 14.1963L1.35155 12.2374Z"
              stroke="black"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
          </svg>
          <span>Home</span>
        </NavLink>

        <NavLink
          to="/events"
          className={({ isActive }) =>
            isActive || location.pathname.startsWith("/eventdetails")
              ? "active"
              : ""
          }
        >
          {" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M17 1.02393V3.02393M5 1.02393V3.02393"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.9955 12.0239H11.0045M10.9955 16.0239H11.0045M14.991 12.0239H15M7 12.0239H7.00897M7 16.0239H7.00897"
              stroke="#141B34"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.5 7.02393H19.5"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1.5 11.2672C1.5 6.90986 1.5 4.73121 2.75212 3.37757C4.00424 2.02393 6.01949 2.02393 10.05 2.02393H11.95C15.9805 2.02393 17.9958 2.02393 19.2479 3.37757C20.5 4.73121 20.5 6.90986 20.5 11.2672V11.7807C20.5 16.138 20.5 18.3166 19.2479 19.6703C17.9958 21.0239 15.9805 21.0239 11.95 21.0239H10.05C6.01949 21.0239 4.00424 21.0239 2.75212 19.6703C1.5 18.3166 1.5 16.138 1.5 11.7807V11.2672Z"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 7.02393H20"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Events & Calendar</span>
        </NavLink>

        <NavLink
          to="/search"
          className={({ isActive }) =>
            isActive || location.pathname.startsWith("/search") ? "active" : ""
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M16.5 16.5239L21 21.0239"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19 10.0239C19 5.05336 14.9706 1.02393 10 1.02393C5.02944 1.02393 1 5.05336 1 10.0239C1 14.9945 5.02944 19.0239 10 19.0239C14.9706 19.0239 19 14.9945 19 10.0239Z"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
          </svg>
          <span>Search</span>
        </NavLink>

        <NavLink
          to="/resources"
          className={({ isActive }) =>
            isActive || location.pathname.startsWith("/resources")
              ? "active"
              : ""
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 20 22"
            fill="none"
          >
            <path
              d="M18.5 15.9525V9.02393C18.5 5.25269 18.5 3.36707 17.3284 2.1955C16.1569 1.02393 14.2712 1.02393 10.5 1.02393H9.5C5.72876 1.02393 3.84315 1.02393 2.67157 2.1955C1.5 3.36707 1.5 5.25269 1.5 9.02393V18.5239"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M18.5 16.0239H4C2.61929 16.0239 1.5 17.1432 1.5 18.5239C1.5 19.9046 2.61929 21.0239 4 21.0239H18.5"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M18.5 21.0239C17.1193 21.0239 16 19.9046 16 18.5239C16 17.1432 17.1193 16.0239 18.5 16.0239"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M13 6.02393L7 6.02393"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 10.0239L7 10.0239"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Resources</span>
        </NavLink>

        <NavLink
          to="/donate"
          className={({ isActive }) =>
            isActive || location.pathname.startsWith("/donate") ? "active" : ""
          }
        >
          {" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 20 22"
            fill="none"
          >
            <path
              d="M2 10.0239V14.0239C2 17.3238 2 18.9737 3.02513 19.9988C4.05025 21.0239 5.70017 21.0239 9 21.0239H11C14.2998 21.0239 15.9497 21.0239 16.9749 19.9988C18 18.9737 18 17.3238 18 14.0239V10.0239"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 8.02393C1 7.27623 1 6.90239 1.20096 6.62393C1.33261 6.4415 1.52197 6.29002 1.75 6.1847C2.09808 6.02393 2.56538 6.02393 3.5 6.02393H16.5C17.4346 6.02393 17.9019 6.02393 18.25 6.1847C18.478 6.29002 18.6674 6.4415 18.799 6.62393C19 6.90239 19 7.27623 19 8.02393C19 8.77162 19 9.14546 18.799 9.42393C18.6674 9.60635 18.478 9.75783 18.25 9.86316C17.9019 10.0239 17.4346 10.0239 16.5 10.0239H3.5C2.56538 10.0239 2.09808 10.0239 1.75 9.86316C1.52197 9.75783 1.33261 9.60635 1.20096 9.42393C1 9.14546 1 8.77162 1 8.02393Z"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
            <path
              opacity="0.4"
              d="M10 6.02393V4.88107M10 6.02393H7.21429C5.43908 6.02393 4 4.58484 4 2.80964C4 1.82342 4.79949 1.02393 5.78571 1.02393H6.14286C8.2731 1.02393 10 2.75083 10 4.88107M10 6.02393H12.7857C14.5609 6.02393 16 4.58484 16 2.80964C16 1.82342 15.2005 1.02393 14.2143 1.02393H13.8571C11.7269 1.02393 10 2.75083 10 4.88107"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
            <path
              opacity="0.4"
              d="M10 10.0239L10 21.0239"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Donate & Give</span>
        </NavLink>

        <NavLink
          to="/testimony"
          className={({ isActive }) =>
            isActive || location.pathname.startsWith("/testimony")
              ? "active"
              : ""
          }
        >
          {" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M13.1706 19.9145C17.3536 19.6364 20.6856 16.2572 20.9598 12.0148C21.0134 11.1846 21.0134 10.3249 20.9598 9.49465C20.6856 5.2523 17.3536 1.87306 13.1706 1.595C11.7435 1.50014 10.2536 1.50033 8.8294 1.595C4.64639 1.87306 1.31441 5.2523 1.04024 9.49465C0.986587 10.3249 0.986587 11.1846 1.04024 12.0148C1.1401 13.5599 1.82343 14.9905 2.62791 16.1985C3.09501 17.0442 2.78674 18.0998 2.30021 19.0217C1.94941 19.6865 1.77401 20.0189 1.91484 20.259C2.05568 20.4991 2.37026 20.5068 2.99943 20.5221C4.24367 20.5524 5.08268 20.1997 5.74868 19.7086C6.1264 19.43 6.31527 19.2907 6.44544 19.2747C6.5756 19.2587 6.83177 19.3642 7.34401 19.5752C7.8044 19.7648 8.33896 19.8819 8.8294 19.9145C10.2536 20.0091 11.7435 20.0093 13.1706 19.9145Z"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
            <path
              d="M10.9953 11.0239H11.0043M14.9908 11.0239H14.9998M6.99981 11.0239H7.00878"
              stroke="#141B34"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Testimonies</span>
        </NavLink>

        <NavLink
          to="/prayer"
          className={({ isActive }) =>
            isActive || location.pathname.startsWith("/prayer") ? "active" : ""
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M14.5 14.0239L13 9.52393C11.3432 9.52385 11 10.867 11 12.5238V14.0239"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.5 14.0239L9 9.52393C10.6568 9.52385 11 10.867 11 12.5238V14.0239"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20.9779 21.0239C19.8283 20.3534 17.8918 18.8383 15.2887 19.0319C14.6292 19.0809 14.2991 19.1055 13.9976 19.0823C13.696 19.0591 13.6875 19.0572 13.6706 19.0533C12.139 18.6985 11 17.3596 11 15.7621L11 2.22057C11 1.55971 11.5357 1.02396 12.1966 1.02393C12.6825 1.0239 13.1202 1.31773 13.3042 1.76748L16.0224 8.41192C17.088 11.0169 17.6209 12.3194 18.5497 12.9892C18.6069 13.0304 18.7128 13.1016 18.7726 13.1389C19.7443 13.7449 20.1628 13.7449 21 13.7449"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1.02208 21.0239C2.17173 20.3534 4.1082 18.8383 6.71127 19.0319C7.37081 19.081 7.70094 19.1055 8.00245 19.0824C8.304 19.0592 8.31246 19.0572 8.32938 19.0533C9.86101 18.6985 11 17.3596 11 15.7621L11 2.22056C11 1.55968 10.4642 1.02393 9.80336 1.02393C9.31746 1.02393 8.8798 1.31775 8.69582 1.76748L5.97762 8.41196C4.91195 11.0169 4.37912 12.3194 3.45028 12.9893C3.39315 13.0305 3.28717 13.1016 3.22741 13.1389C2.25573 13.745 1.83715 13.745 1 13.745"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Prayer & Support</span>
        </NavLink>

        <NavLink
          to="/feedback"
          className={({ isActive }) => (isActive ? "active" : "")}
          end
        >
          {" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M7 12.5239H15M7 7.52393H11"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.09881 18.0239C3.7987 17.896 2.82475 17.5055 2.17157 16.8524C1 15.6808 1 13.7952 1 10.0239V9.52393C1 5.75269 1 3.86707 2.17157 2.6955C3.34315 1.52393 5.22876 1.52393 9 1.52393H13C16.7712 1.52393 18.6569 1.52393 19.8284 2.6955C21 3.86707 21 5.75269 21 9.52393V10.0239C21 13.7952 21 15.6808 19.8284 16.8524C18.6569 18.0239 16.7712 18.0239 13 18.0239C12.4395 18.0364 11.9931 18.0791 11.5546 18.179C10.3562 18.4548 9.24652 19.0681 8.14987 19.6028C6.58729 20.3647 5.806 20.7457 5.31569 20.389C4.37769 19.6904 5.29454 17.5258 5.5 16.5239"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
          <span>Send Feedback</span>
        </NavLink>

        <NavLink
          to="/settings"
          className={({ isActive }) =>
            `desktopsettings ${isActive ? "active" : ""}`
          }
          end
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M20.3175 6.16532L19.8239 5.30872C19.4506 4.66089 19.264 4.33697 18.9464 4.20781C18.6288 4.07864 18.2696 4.18056 17.5513 4.38441L16.3311 4.72811C15.8725 4.83386 15.3913 4.77387 14.9726 4.55872L14.6357 4.36434C14.2766 4.13436 14.0004 3.79526 13.8475 3.39667L13.5136 2.39928C13.294 1.73926 13.1842 1.40925 12.9228 1.2205C12.6615 1.03174 12.3143 1.03174 11.6199 1.03174L10.5051 1.03174C9.81078 1.03174 9.4636 1.03174 9.20223 1.2205C8.94085 1.40925 8.83106 1.73926 8.61149 2.39928L8.27753 3.39667C8.12465 3.79526 7.84845 4.13436 7.48937 4.36434L7.15249 4.55872C6.73374 4.77387 6.25259 4.83386 5.79398 4.72811L4.57375 4.38441C3.85541 4.18056 3.49625 4.07864 3.17867 4.20781C2.86109 4.33697 2.67445 4.66089 2.30115 5.30872L1.80757 6.16532C1.45766 6.77257 1.2827 7.07619 1.31666 7.39941C1.35061 7.72263 1.58483 7.9831 2.05326 8.50404L3.0843 9.65675C3.3363 9.97577 3.51521 10.5317 3.51521 11.0316C3.51521 11.5317 3.33636 12.0876 3.08433 12.4066L2.05326 13.5593C1.58483 14.0803 1.35062 14.3408 1.31666 14.664C1.2827 14.9872 1.45766 15.2908 1.80757 15.8981L2.30114 16.7546C2.67443 17.4025 2.86109 17.7264 3.17867 17.8556C3.49625 17.9847 3.85542 17.8828 4.57377 17.6789L5.79394 17.3352C6.25263 17.2295 6.73387 17.2895 7.15267 17.5047L7.4895 17.6991C7.84851 17.9291 8.12464 18.2682 8.2775 18.6667L8.61149 19.6642C8.83106 20.3242 8.94085 20.6542 9.20223 20.843C9.4636 21.0317 9.81078 21.0317 10.5051 21.0317H11.6199C12.3143 21.0317 12.6615 21.0317 12.9228 20.843C13.1842 20.6542 13.294 20.3242 13.5136 19.6642L13.8476 18.6667C14.0004 18.2682 14.2765 17.9291 14.6356 17.6991L14.9724 17.5047C15.3912 17.2895 15.8724 17.2295 16.3311 17.3352L17.5513 17.6789C18.2696 17.8828 18.6288 17.9847 18.9464 17.8556C19.264 17.7264 19.4506 17.4025 19.8239 16.7546L20.3175 15.8981C20.6674 15.2908 20.8423 14.9872 20.8084 14.664C20.7744 14.3408 20.5402 14.0803 20.0718 13.5593L19.0407 12.4066C18.7887 12.0876 18.6098 11.5317 18.6098 11.0316C18.6098 10.5317 18.7888 9.97577 19.0407 9.65675L20.0718 8.50404C20.5402 7.9831 20.7744 7.72263 20.8084 7.39941C20.8423 7.07619 20.6674 6.77257 20.3175 6.16532Z"
              stroke="#141B34"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M14.5195 11.0239C14.5195 12.9569 12.9525 14.5239 11.0195 14.5239C9.08653 14.5239 7.51953 12.9569 7.51953 11.0239C7.51953 9.09093 9.08653 7.52393 11.0195 7.52393C12.9525 7.52393 14.5195 9.09093 14.5195 11.0239Z"
              stroke="#141B34"
              strokeWidth="1.5"
            />
          </svg>
          <span>Settings</span>
        </NavLink>

        <button onClick={handleLogout} className="flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M13 15.6489C12.9264 17.5008 11.3831 19.0733 9.31564 19.0227C8.83465 19.011 8.24013 18.8433 7.05112 18.5079C4.18961 17.7008 1.70555 16.3443 1.10956 13.3055C1 12.7469 1 12.1183 1 10.8612L1 9.18667C1 7.92954 1 7.30097 1.10956 6.74238C1.70555 3.70358 4.18961 2.34709 7.05112 1.53995C8.24014 1.20457 8.83465 1.03688 9.31564 1.02511C11.3831 0.974535 12.9264 2.547 13 4.39893"
              stroke="#FF0000"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M19 10.0239H8M19 10.0239C19 9.3237 17.0057 8.01546 16.5 7.52393M19 10.0239C19 10.7242 17.0057 12.0324 16.5 12.5239"
              stroke="#FF0000"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="logouts">
            {loading ? "Logging out..." : "Logout"}
          </span>
        </button>
      </div>

      <CustomModal
        isOpen={showModal}
        title="Are you logging out?"
        message="You're about to end your session. See you again soon and stay blessed!"
        secondaryText="Cancel"
        primaryText={loading ? "Logging out..." : "Yes, Logout"}
        onPrimary={handleLetsDoThis}
        onSecondary={handleDoThisLater}
        icon={personIcon}
      />
    </div>
  );
}
